import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from "@react-pdf/renderer";
import moment from "moment";

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 10
  },
  title: {
    fontSize: 20,
    textAlign: "center",
    marginBottom: 10
  },
  author: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 5
  },
  image: {
    width: 150,
    marginVertical: 15,
    marginHorizontal: 0
  },
  fecha: {
    fontSize: 12,
    textAlign: "right"
  },
  rangoFecha: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 5
  },
  rangoFechas: {
    fontSize: 10,
    textAlign: "center"
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol70: {
    backgroundColor: "lightblue",
    width: "70%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol30: {
    backgroundColor: "lightblue",
    width: "30%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol70D: {
    backgroundColor: "white",
    width: "70%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol30D: {
    backgroundColor: "white",
    width: "30%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol25: {
    backgroundColor: "lightblue",
    width: "25%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol25D: {
    backgroundColor: "white",
    width: "25%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol: {
    width: "14%",
    borderStyle: "solid",
    borderWidth: 0,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10
  },
  footer: {
    position: "absolute",
    fontSize: 10,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey"
  }
});

// Create Document Component
const MyDocument = props => (
  <Document>
    <Page size="A4" style={styles.body}>
      <View style={styles.section}>
        <Image style={styles.image} src={props.url} />
        <Text style={styles.fecha}>
          {moment(new Date()).format("DD/MM/YYYY")}
        </Text>
        <Text style={styles.title}>Reporte de Caso</Text>
        {props.data.map(i => {
          return (
            <View>
              <Text style={{ fontSize: 10 }}>INFORMACIÓN GENERAL</Text>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol70}>
                    <Text style={styles.tableCell}>
                      NOMBRE(S), APELLIDO PATERNO / APELLIDO MATERNO /
                      DENOMINACION O RAZON SOCIAL
                    </Text>
                  </View>
                  <View style={styles.tableCol30}>
                    <Text style={styles.tableCell}>NO. CASO </Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol70D}>
                    <Text style={styles.tableCell}>{i.body}</Text>
                  </View>
                  <View style={styles.tableCol30D}>
                    <Text style={styles.tableCell}>{i.title}</Text>
                  </View>
                </View>
              </View>

              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol70}>
                    <Text style={styles.tableCell}>DIRECCION </Text>
                  </View>
                  <View style={styles.tableCol30}>
                    <Text style={styles.tableCell}>FECHA DE ALTA </Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol70D}>
                    <Text style={styles.tableCell}>{i.domicilio}</Text>
                  </View>
                  <View style={styles.tableCol30D}>
                    <Text style={styles.tableCell}>
                      {moment(i.creadoFecha.toDate()).format("DD/MM/YYYY")}
                    </Text>
                  </View>
                </View>
              </View>

              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol25}>
                    <Text style={styles.tableCell}>CORREO ELECTRONICO</Text>
                  </View>
                  <View style={styles.tableCol25}>
                    <Text style={styles.tableCell}>TELEFONO</Text>
                  </View>
                  <View style={styles.tableCol25}>
                    <Text style={styles.tableCell}>CURP</Text>
                  </View>
                  <View style={styles.tableCol25}>
                    <Text style={styles.tableCell}>RFC</Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol25D}>
                    <Text style={styles.tableCell}>{i.email}</Text>
                  </View>
                  <View style={styles.tableCol25D}>
                    <Text style={styles.tableCell}>{i.telefono}</Text>
                  </View>
                  <View style={styles.tableCol25D}>
                    <Text style={styles.tableCell}>{i.curp}</Text>
                  </View>
                  <View style={styles.tableCol25D}>
                    <Text style={styles.tableCell}>{i.rfc}</Text>
                  </View>
                </View>
              </View>
              <Text style={{ fontSize: 10, marginTop: "20px" }}>
                INFORMACIÓN DEL CASO
              </Text>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol30}>
                    <Text style={styles.tableCell}>MATERIA</Text>
                  </View>
                  <View style={styles.tableCol70}>
                    <Text style={styles.tableCell}>MATERIA</Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol30D}>
                    <Text style={styles.tableCell}>{i.ramo}</Text>
                  </View>
                  <View style={styles.tableCol70D}>
                    <Text style={styles.tableCell}>{i.aseguradora}</Text>
                  </View>
                </View>
              </View>

              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol30}>
                    <Text style={styles.tableCell}>RECLAMACION</Text>
                  </View>
                  <View style={styles.tableCol70}>
                    <Text style={styles.tableCell}>ASUNTO</Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol30D}>
                    <Text style={styles.tableCell}>{i.tiposeguro}</Text>
                  </View>
                  <View style={styles.tableCol70D}>
                    <Text style={styles.tableCell}>{i.asunto}</Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol25}>
                    <Text style={styles.tableCell}>MONTO CUANTIA</Text>
                  </View>
                  <View style={styles.tableCol25}>
                    <Text style={styles.tableCell}>CONTRATO PRST. SERV.</Text>
                  </View>
                  <View style={styles.tableCol25}>
                    <Text style={styles.tableCell}>HONORARIOS</Text>
                  </View>
                  <View style={styles.tableCol25}>
                    <Text style={styles.tableCell}>ANTICIPO</Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol25D}>
                    <Text style={styles.tableCell}>${i.monto}</Text>
                  </View>
                  <View style={styles.tableCol25D}>
                    <Text style={styles.tableCell}>
                      {i.contrato ? "Si" : "No"}
                    </Text>
                  </View>
                  <View style={styles.tableCol25D}>
                    <Text style={styles.tableCell}>{i.honorarios}</Text>
                  </View>
                  <View style={styles.tableCol25D}>
                    <Text style={styles.tableCell}>{i.anticipo}</Text>
                  </View>
                </View>
              </View>
              {/*********Inicia Fase 1 */}
              {i.fase1 ? (
                <>
                  <Text style={{ fontSize: 10, marginTop: "20px" }}>
                    ETAPA 1 : DIRECTA
                  </Text>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30}>
                        <Text style={styles.tableCell}>NO. SINIESTRO</Text>
                      </View>
                      <View style={styles.tableCol70}>
                        <Text style={styles.tableCell}>
                          INSTITUCION / ORGANISMO
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          {i.fase1.numSinsitro}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.aseguradora}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30}>
                        <Text style={styles.tableCell}>FECHAS</Text>
                      </View>
                      <View style={styles.tableCol70}>
                        <Text style={styles.tableCell}>DESCRIPCION</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Reclamo{" "}
                          {i.fase1.fechaReclamo
                            ? moment(i.fase1.fechaReclamo.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase1.coment1}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Respuesta de Reclamo{" "}
                          {i.fase1.fechaRespueRecl
                            ? moment(i.fase1.fechaRespueRecl.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase1.coment2}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Informe Adicional{" "}
                          {i.fase1.fechaInfoAdici
                            ? moment(i.fase1.fechaInfoAdici.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase1.coment3}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Entrega Informe Adic.{" "}
                          {i.fase1.fechaEntregInfAdi
                            ? moment(i.fase1.fechaEntregInfAdi.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase1.coment4}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Entrega Informe Final{" "}
                          {i.fase1.fechaEntregInfFin
                            ? moment(i.fase1.fechaEntregInfFin.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase1.coment5}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Respuesta Aseguradora{" "}
                          {i.fase1.fechaRespFinalAseg
                            ? moment(
                                i.fase1.fechaRespFinalAseg.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase1.coment6}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Informe Final{" "}
                          {i.fase1.fechaInformeFinal
                            ? moment(i.fase1.fechaInformeFinal.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase1.coment7}</Text>
                      </View>
                    </View>
                  </View>
                </>
              ) : null}
              {/********************************Inicia Fase 2 */}
              {i.fase2 ? (
                <>
                  <Text style={{ fontSize: 10, marginTop: "70px" }}>
                    ETAPA 2: CONDUSEF
                  </Text>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30}>
                        <Text style={styles.tableCell}>NO. SINIESTRO</Text>
                      </View>
                      <View style={styles.tableCol70}>
                        <Text style={styles.tableCell}>CODUSEF </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>{i.fase2.numExped}</Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase2.condusef}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30}>
                        <Text style={styles.tableCell}>FECHAS</Text>
                      </View>
                      <View style={styles.tableCol70}>
                        <Text style={styles.tableCell}>DESCRIPCION</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Admision{" "}
                          {i.fase2.fechaAdmis
                            ? moment(i.fase2.fechaAdmis.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase2.coment1}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Informe via Electronico{" "}
                          {i.fase2.fechaInfoViaElect
                            ? moment(i.fase2.fechaInfoViaElect.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase2.coment2}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Audiencia Conciliatoria{" "}
                          {i.fase2.fechaAudConcil
                            ? moment(i.fase2.fechaAudConcil.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase2.coment3}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Informe Adicional{" "}
                          {i.fase2.fechaPrestInofAd
                            ? moment(i.fase2.fechaPrestInofAd.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase2.coment4}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Audiencia Final{" "}
                          {i.fase2.fechaAudienFinal
                            ? moment(i.fase2.fechaAudienFinal.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase2.coment5}</Text>
                      </View>
                    </View>
                  </View>
                </>
              ) : null}
              {/********************************Inicia Fase 3 Mercantil */}
              {i.fase3M ? (
                <>
                  <Text style={{ fontSize: 10, marginTop: "20px" }}>
                    ETAPA 3: ORAL MERCANTIL
                  </Text>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30}>
                        <Text style={styles.tableCell}>NO. EXPEDIENTE</Text>
                      </View>
                      <View style={styles.tableCol70}>
                        <Text style={styles.tableCell}>JUZGADO TRIBUNAL</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.numExped}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.nombNumJuz}-{i.fase3M.tribunal}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30}>
                        <Text style={styles.tableCell}>FECHAS</Text>
                      </View>
                      <View style={styles.tableCol70}>
                        <Text style={styles.tableCell}>DESCRIPCION</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Presentacion de Demanda{" "}
                          {i.fase3M.fechaPrestDem
                            ? moment(i.fase3M.fechaPrestDem.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3M.coment1}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Radicacion de Demanda{" "}
                          {i.fase3M.fechaRadicDem
                            ? moment(i.fase3M.fechaRadicDem.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3M.coment2}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Emplazamiento{" "}
                          {i.fase3M.fechaEmplazam
                            ? moment(i.fase3M.fechaEmplazam.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3M.coment3}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Contestacion de Demanda{" "}
                          {i.fase3M.fechaContestDem
                            ? moment(i.fase3M.fechaContestDem.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3M.coment4}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Admis. Contest. Demanda{" "}
                          {i.fase3M.fechaAdmisConte
                            ? moment(i.fase3M.fechaAdmisConte.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3M.coment5}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Contest. Vista Contest.{" "}
                          {i.fase3M.fechaContVistaConte
                            ? moment(
                                i.fase3M.fechaContVistaConte.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3M.coment6}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Admis. Contest. Vista.{" "}
                          {i.fase3M.fechaAdmisConteVist
                            ? moment(
                                i.fase3M.fechaAdmisConteVist.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3M.coment7}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Impugnacion Documento{" "}
                          {i.fase3M.fechaImpugnDoc
                            ? moment(i.fase3M.fechaImpugnDoc.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3M.coment8}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Ofrecimiento de Pruebas Demand.{" "}
                          {i.fase3M.fechaOfrecPrueDem
                            ? moment(
                                i.fase3M.fechaOfrecPrueDem.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3M.coment9}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Auto Admite Actora{" "}
                          {i.fase3M.fechaAutoAdmiActora
                            ? moment(
                                i.fase3M.fechaAutoAdmiActora.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment10}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Confesional{" "}
                          {i.fase3M.fechaPDConfesional
                            ? moment(
                                i.fase3M.fechaPDConfesional.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Testimonial{" "}
                          {i.fase3M.fechaPDTestimonial
                            ? moment(
                                i.fase3M.fechaPDTestimonial.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Declaracion de Parte{" "}
                          {i.fase3M.fechaPDDecParte
                            ? moment(i.fase3M.fechaPDDecParte.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Declaracion de Tercero{" "}
                          {i.fase3M.fechaPDDecTercero
                            ? moment(
                                i.fase3M.fechaPDDecTercero.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Pericial{" "}
                          {i.fase3M.fechaPDPericial
                            ? moment(i.fase3M.fechaPDPericial.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Inspeccion Judicial{" "}
                          {i.fase3M.fechaPDInspJudic
                            ? moment(i.fase3M.fechaPDInspJudic.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Reconstruccion de Hechos{" "}
                          {i.fase3M.fechaPDRecHechos
                            ? moment(i.fase3M.fechaPDRecHechos.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Ratificacion Contenido y Firma{" "}
                          {i.fase3M.fechaPDRatifContFir
                            ? moment(
                                i.fase3M.fechaPDRatifContFir.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Auto Admite Demanda{" "}
                          {i.fase3M.fechaAutoAdmiDeman
                            ? moment(
                                i.fase3M.fechaAutoAdmiDeman.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment11}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Confesional{" "}
                          {i.fase3M.fechaPD2Confesional
                            ? moment(
                                i.fase3M.fechaPD2Confesional.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Testimonial{" "}
                          {i.fase3M.fechaPD2Testimonial
                            ? moment(
                                i.fase3M.fechaPD2Testimonial.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Declaracion de Parte{" "}
                          {i.fase3M.fechaPD2DecParte
                            ? moment(i.fase3M.fechaPD2DecParte.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Declaracion de Tercero{" "}
                          {i.fase3M.fechaPD2DecTercero
                            ? moment(
                                i.fase3M.fechaPD2DecTercero.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Pericial{" "}
                          {i.fase3M.fechaPD2Pericial
                            ? moment(i.fase3M.fechaPD2Pericial.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Inspeccion Judicial{" "}
                          {i.fase3M.fechaPD2InspJudic
                            ? moment(
                                i.fase3M.fechaPD2InspJudic.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Reconstruccion de Hechos{" "}
                          {i.fase3M.fechaPD2RecHechos
                            ? moment(
                                i.fase3M.fechaPD2RecHechos.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Ratificacion Contenido y Firma{" "}
                          {i.fase3M.fechaPD2RatifContFir
                            ? moment(
                                i.fase3M.fechaPD2RatifContFir.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}></Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Apertura Alegatos{" "}
                          {i.fase3M.fechaApertuAleg
                            ? moment(i.fase3M.fechaApertuAleg.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment12}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Citacion Sentencia{" "}
                          {i.fase3M.fechaCitaSent
                            ? moment(i.fase3M.fechaCitaSent.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment13}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Sentencia Definitiva{" "}
                          {i.fase3M.fechaSentDefin
                            ? moment(i.fase3M.fechaSentDefin.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment14}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Presentacion Rec. Apel.{" "}
                          {i.fase3M.fechaPresentRecApe
                            ? moment(
                                i.fase3M.fechaPresentRecApe.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment15}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Reso. Segu. Inst.{" "}
                          {i.fase3M.fechaResSegInst
                            ? moment(i.fase3M.fechaResSegInst.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment16}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Presentacion Amparo{" "}
                          {i.fase3M.fechaPresentAmp
                            ? moment(i.fase3M.fechaPresentAmp.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment17}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Ejecutoria Amparo{" "}
                          {i.fase3M.fechaEjecAmp
                            ? moment(i.fase3M.fechaEjecAmp.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment18}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Cumplimentadora{" "}
                          {i.fase3M.fechaCumplim
                            ? moment(i.fase3M.fechaCumplim.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3M.coment19}
                        </Text>
                      </View>
                    </View>
                  </View>
                </>
              ) : null}
              {/********************************Inicia Fase 3 Oral */}
              {i.fase3O ? (
                <>
                  <Text style={{ fontSize: 10, marginTop: "20px" }}>
                    ETAPA 3: ORDINARIA MERCANTIL
                  </Text>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30}>
                        <Text style={styles.tableCell}>NO. EXPEDIENTE</Text>
                      </View>
                      <View style={styles.tableCol70}>
                        <Text style={styles.tableCell}>JUZGADO TRIBUNAL</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          {i.fase3O.numExped}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3O.nombNumJuz}-{i.fase3O.tribunal}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30}>
                        <Text style={styles.tableCell}>FECHAS</Text>
                      </View>
                      <View style={styles.tableCol70}>
                        <Text style={styles.tableCell}>DESCRIPCION</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Presentacion de Demanda{" "}
                          {i.fase3O.fechaPrestDem
                            ? moment(i.fase3O.fechaPrestDem.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3O.coment1}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Radic. Demanda{" "}
                          {i.fase3O.fechaRadicDem
                            ? moment(i.fase3O.fechaRadicDem.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3O.coment2}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Emplazamiento{" "}
                          {i.fase3O.fechaEmplazam
                            ? moment(i.fase3O.fechaEmplazam.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3O.coment3}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Contest. Demanda{" "}
                          {i.fase3O.fechaContestDem
                            ? moment(i.fase3O.fechaContestDem.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3O.coment4}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Admis. Contest. Demanda{" "}
                          {i.fase3O.fechaAdmisConte
                            ? moment(i.fase3O.fechaAdmisConte.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3O.coment5}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Contest. Vista Contest.{" "}
                          {i.fase3O.fechaContVistaConte
                            ? moment(
                                i.fase3O.fechaContVistaConte.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3O.coment6}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Admis. Contest. Vista.{" "}
                          {i.fase3O.fechaAdmisConteVist
                            ? moment(
                                i.fase3O.fechaAdmisConteVist.toDate()
                              ).format("DD/MM/YYYY")
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3O.coment7}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Audiencia Preliminar{" "}
                          {i.fase3O.fechaAudiePrelim
                            ? moment(i.fase3O.fechaAudiePrelim.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3O.coment8}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Audiencia Juicio{" "}
                          {i.fase3O.fechaAudieJuicio
                            ? moment(i.fase3O.fechaAudieJuicio.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>{i.fase3O.coment9}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Sentencia{" "}
                          {i.fase3O.fechaSentencia
                            ? moment(i.fase3O.fechaSentencia.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3O.coment10}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Ejecutoria Amparo{" "}
                          {i.fase3O.fechaEjecuAmpar
                            ? moment(i.fase3O.fechaEjecuAmpar.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3O.coment12}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Cumplimentadora{" "}
                          {i.fase3O.fechaCumplim
                            ? moment(i.fase3O.fechaCumplim.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3O.coment13}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableCol30D}>
                        <Text style={styles.tableCell}>
                          Cumplimentadora{" "}
                          {i.fase3O.fechaCumplim2
                            ? moment(i.fase3O.fechaCumplim2.toDate()).format(
                                "DD/MM/YYYY"
                              )
                            : ""}
                        </Text>
                      </View>
                      <View style={styles.tableCol70D}>
                        <Text style={styles.tableCell}>
                          {i.fase3O.coment14}
                        </Text>
                      </View>
                    </View>
                  </View>
                </>
              ) : null}
            </View>
          );
        })}
      </View>
      <Text style={styles.footer} fixed>
        {`${props.direccion} \n ${props.ciudad} \n ${props.telefono}`}
      </Text>
    </Page>
  </Document>
);

export default MyDocument;
